import React from "react";
import classes from "./BurgerIngredient.module.css";

function Cheese() {
  return <div className={classes.Cheese}></div>;
}

export default Cheese;
